import React from 'react';
import { connect } from 'react-redux';

//Components 
import { setActiveEditScreen } from 'components/collage/CollageSlice.js'

// CSS
import './SubScreenSlide.css';

class SubScreenSlide extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      cssClass: 'SubScreenSlide',
      display: this.props.active ? 'flex' : 'none'
    }
  }

  componentDidUpdate(prevProps, prevState) {
    
    // If display state has change
    if ( this.props.active != prevProps.active ) {
      
      // If showing
      if ( this.props.active ) {  
        this.setState({
          cssClass: 'SubScreenSlide SubScreenSlide--SlideIn',
          // display: 'block'
        });
        setTimeout(() => {
          this.setState({
            cssClass: 'SubScreenSlide',
            // display: 'block'
          });
        }, 150);
      }
      // If hiding
      else {
        this.setState({
          cssClass: 'SubScreenSlide SubScreenSlide--SlideOut'
        });
      }

      setTimeout(() => {
        this.setState({
          // cssClass: 'SubScreenSlide',
          display: this.props.active ? 'flex' : 'none'
        })
      },150);

    }

  }

  render() {
    return (
      <div 
        className={this.state.cssClass}
        style={{display: this.state.display}}
      >
        {this.props.backLink &&
          <button 
            className="SubScreenBack ButtonReset"
            onClick={() => this.props.setActiveEditScreen('main')}
          >
            <span>Back</span>
          </button>
        }
        {this.props.children}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  collage: state.collage
});

export default connect(
  mapStateToProps,
  { setActiveEditScreen }
)(SubScreenSlide)
